import React from "react";
import PropTypes from "prop-types";
import { Link as MuiLink } from "@mui/material";
import { useSelector } from "react-redux";

import Card from "../../../Card";
import CompanyOverviewField from "../shared/CompanyOverviewField";
import messages from "../../../../assets/locale/messages";

const ContactPersonCard = ({ owner }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { companiesList: t } = messages[lang];

  if (!owner) return null;

  const phoneNumber = `${owner?.country?.dial_code || ""}${owner?.phone_number || ""}`;

  return (
    <Card
      title={t.contactPerson}
      classNames={{ body: "company-overview-card__body" }}
    >
      <div className="company-overview-field-grid company-overview-field-grid--cols-3">
        <CompanyOverviewField
          label={t.fullName}
          value={owner.name || "—"}
        />
        <CompanyOverviewField
          label={t.mobileNumber}
          value={phoneNumber || "—"}
          valueClassName="company-overview-field__value--phone"
        />
        <CompanyOverviewField label={t.emailAddress}>
          {owner.email ? (
            <MuiLink href={`mailto:${owner.email}`} underline="hover">
              {owner.email}
            </MuiLink>
          ) : (
            "—"
          )}
        </CompanyOverviewField>
      </div>
    </Card>
  );
};

ContactPersonCard.propTypes = {
  owner: PropTypes.object,
};

ContactPersonCard.defaultProps = {
  owner: null,
};

export default ContactPersonCard;
